import { useServices } from '@/components/ServiceContext.tsx';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage.tsx';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const CCHouseListReport: React.FC = () => {
  const { houseListService } = useServices();

  const report = reportDefinitions.find(
    rd => rd.id === 'report-hl-cc-house-list'
  );

  return (
    report && (
      <GenericReportPage
        listType="houselist"
        listService={houseListService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default CCHouseListReport;
